import React from "react"
import styled from "styled-components"

import Logo, { LogoURL } from "~/components/atoms/Logo"
import { Container } from "~/components/layouts/Container"
import { Color, Z, SpacingSize } from "~/consts/style-mixins"

export const HeaderForAuthRegister: React.VFC = () => {
  return (
    <StyledHeaderWrapper>
      <Container size="Large">
        <StyledHeaderInner>
          <StyledLogo href={LogoURL["Plain"]}>
            <Logo type="Plain" height={32} />
          </StyledLogo>
        </StyledHeaderInner>
      </Container>
    </StyledHeaderWrapper>
  )
}

const StyledLogo = styled.a`
  height: 32px;
`

const StyledHeaderWrapper = styled.div`
  background-color: ${Color.White};
  border-bottom: 1px solid ${Color.BorderGray};
  z-index: ${Z.Header};
`

const StyledHeaderInner = styled.div`
  padding: ${SpacingSize.M}px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`
